export default {
      id: "icon-email-usage",
      viewBox: "0 0 26 20",
      url: "../icon/" + "icons.svg#icon-email-usage",
      toString: function () {
        return this.url;
      }
    }